if (!customElements.get("recently-viewed-products")) {
  customElements.define(
    "recently-viewed-products",
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();

        this.productIds = [];
        const url = this.constructQueryUrl();
        if (!url) return;

        this.obsever = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();

            this.fetchData(url);
          },
          { rootMargin: "0px 0px 400px 0px" },
        );

        this.obsever.observe(this);
      }

      disconnectedCallback() {
        if (this.obsever) this.obsever.disconnect();
      }

      fetchData(url) {
        fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Network response was not ok: ${response.statusText}`,
              );
            }
            return response.text();
          })
          .then((text) => {
            this.renderHtml(text);
          })
          .catch((error) => {
            popToast(window["variantStrings"]["unknownError"], "error");
          });
      }

      renderHtml(html) {
        const sourceDom = new DOMParser().parseFromString(html, "text/html");
        const sourceRecentlyViewedMain = sourceDom.querySelector(
          ".recently-viewed-main",
        );

        if (sourceRecentlyViewedMain) {
          // 处理排序
          const itemListWrapper =
            sourceRecentlyViewedMain.querySelector(".slider-wrapper");
          const fragment = document.createDocumentFragment();
          this.productIds.forEach((id) => {
            const item = itemListWrapper.querySelector(
              `li[data-product-id="${id}"]`,
            );
            if (item) {
              fragment.appendChild(item);
            }
          });

          // 清空父容器并重新插入排序后的元素
          itemListWrapper.innerHTML = "";
          itemListWrapper.appendChild(fragment);

          this.querySelector(".products-container").innerHTML =
            sourceRecentlyViewedMain.outerHTML;
        } else {
          this.remove();
        }

        // 加载完成状态
        initializeScrollLazyImageTrigger();
        initializeToolTipTrigger();
      }

      constructQueryUrl() {
        const limit = parseInt(this.dataset.limit) || 5;

        this.productIds = retrieveData(RECENTLY_VIEWED_KEY)
          .slice(-limit)
          .reverse();
        if (!this.productIds || this.productIds.length <= 0) return null;

        const baseUrl = this.dataset.searchUrl;
        const query = this.productIds.map((id) => `id:${id}`).join(" OR ");
        const params = new URLSearchParams({
          q: query,
          "resources[limit]": String(limit),
          "resources[type]": "product",
          section_id: this.dataset.section,
          ose: "false",
        });
        return `${baseUrl}?${params.toString()}`;
      }
    },
  );
}
